<template>
    <div>
        <form class="needs-validation" novalidate>
            <!-- ***** start custom content ***** -->

            <h1>{{$t('seb-title')}}</h1>

            <h2>{{$t('Step 2 of 5: Upload identification')}}</h2>

            <div class="callout callout-warning">
                <p v-html='$t("seb-step-2-note-1")'></p>
                <p v-html='$t("seb-step-2-note-2")'></p>
            </div>


            <div class="row">
                <div class="col-md-7">
                    <fieldset class="mt-4">
                        <legend>{{$t('Attach files')}}</legend>
                        <div class="form-group">
                            <label for="exampleFormControlFile1">{{$t('Upload identification')}}</label>
                            <img :src="image" v-if="hasImage && !newImage" />
                            <image-uploader :debug="1"
                                            :quality="0.5"
                                            :maxSize="3.8"
                                            :scaleRatio="0.5"
                                            :autoRotate=true
                                            outputFormat="verbose"
                                            :preview=true
                                            :className="['form-control-file']"
                                            :capture="false"
                                            accept=".jpg, .png, .jpeg"
                                            @input="setImage"
                                            @onUpload="startImageResize"
                                            @onComplete="endImageResize" required>
                                <label for="fileInput" slot="upload-label">
                                    <span class="upload-caption">
                                        {{
                                            hasImage ? $t("Click to replace") : $t("Click to upload")
                                        }}
                                    </span>
                                </label>
                            </image-uploader>
                            <small id="imageUpload" class="form-text text-muted">
                                {{$t("Files must be JPG or PNG. If providing two documents other than a drivers licence or enhanced identification card, they must be combined in the same image.")}}
                            </small>
                        </div>
                        <div class="invalid-feedback" v-if="!valid_field">{{$t('mandatory_file')}}</div>
                    </fieldset>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col"><button class="btn btn-outline-secondary mt-4 float-right" @click="prev_step">{{$t('previous')}}</button></div>
                <div class="col-auto"><button class="btn btn-secondary mt-4 ml-3" @click="next_step">{{$t('next')}}</button></div>
            </div>
        </form>
    </div>

</template>
<style>
    #fileInput {
        display: "";
    }
    .invalid {
        width: 100%;
        margin-top: 0.25rem;
        font-size: 1rem;
        color: #CE2334;
    }
</style>
<script>
    import $ from "jquery";
    import ImageUploader from 'vue-image-upload-resize'

    var now = new Date();
    // var end_date = new Date('2018-08-27T16:00:00');
    var end_date = new Date('2022-09-02T16:00:00');
    var REGISTRY_CLOSED = (now > end_date);

    export default {
        name: 'VoterApp',
        components: {
            ImageUploader
        },
        data() {
            return {
                maximum_image_size: 4,
                hasImage: false,
                newImage: false,
                image_name: null,
                image: null,
                actual_image: null,
                data: {},
                errors: [],
                voter_id: null,
                registration_id: null,
                response: {},
                addresses: [],
                fetching: false,
                register: false,
                top_address: {},
                registry_closed: REGISTRY_CLOSED,
                address_id: null,
                url: this.$APP_API_URL,
                seb_data: {
                    voterId: 4000000,
                    mailingAddress: "123 Home St",
                    postalCode: "R2R 2R2",
                    contactInfo: "Contact Info",
                    comments: "Comments!",
                    identificationImage: null,
                    action: 'sealed-envelope-ballot'
                },
                eligible_to_vote: false,
                have_not_vote: false,
                agree_to_vote_by_seb: false,
                mailingAddress: null,
                confirm_all_info_is_correct: false,
                voter_signature: null,
                is_robot: true,
                confirmed: false,
            }
        },

        created: function () {
            this.upload_info = this.$store.getters.UPLOAD_INFO;

            if (this.upload_info.length > 0) {
                let info = this.upload_info[0];

                this.hasImage = true;
                this.image = info.image;
                this.image_name = info.image_name;
                this.actual_image = info.actual_image;
            }
        },

        computed: {
            disabled_button() {
                console.log(this.image_name);
                return !(this.image_name);
            },
            valid_field() {
                return (this.image_name);
            }
        },
        methods: {
            setImage(image) {
                console.log('setting image', image);
                if (image.dataUrl) {
                    this.actual_image = image.dataUrl.split(',')[1];
                }
                this.hasImage = true;
                this.newImage = true;
                this.image = image.dataUrl;
                this.image_name = image.info.name;
                console.log('Info', image.info)
                console.log('Exif', image.exif)
            },

            startImageResize(temp) {
                console.log('starting resize', temp);
            },

            endImageResize(temp) {
                console.log('ending resize', temp);
            },

            cancel: function () {
                window.location = "PrivacyAndSecurity.stm";
            },

            next_step: function () {
                // Fetch all the forms we want to apply custom Bootstrap validation styles to
                var forms = document.getElementsByClassName('needs-validation');
                // Loop over them and prevent submission
                var validation = !(this.image_name);
 
                Array.prototype.filter.call(forms, function (form) {
                    if (validation === true) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    form.classList.add('was-validated');

                    $(".invalid-feedback").removeClass("invalid-feedback").addClass("invalid");
                });

                if (validation === false) {
                    var upload_info = {
                        image : this.image,
                        image_name: this.image_name,
                        actual_image: this.actual_image
                    };

                    this.$store.dispatch("SAVE_UPLOAD_INFO", upload_info);

                    this.$router.push({ name: "SealedEnvelopeBallotStep3", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id, registration_id: this.$route.params.registration_id } });
                }
            },
            prev_step: function () {
                this.$router.push({ name: "SealedEnvelopeBallotStep1", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id, registration_id: this.$route.params.registration_id } });
            }
        },

        mounted: function () {

        }
    }
</script>
